// src/Profile.js
import React, { useEffect, useState } from 'react';
// import axios from 'axios';
import axios from "./axiosConfig";
import './Profile.css';
import { useNavigate } from 'react-router-dom';

function Profile() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));
  const [animals, setAnimals] = useState([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!user || !user.id || animals.length > 0) return;

    axios
      // .get(`http://localhost:8080/api/animals/created-by/${user.id}`)
      .get(`/api/animals/created-by/${user.id}`)
      .then((res) => setAnimals(res.data))
      .catch(() => setMessage('Failed to load your posts.'));
  }, [user, animals.length]);

  const handleDelete = async (animalId) => {
    try {
      // await axios.delete(`http://localhost:8080/api/animals/${animalId}?userId=${user.id}`);
      await axios.delete(`/api/animals/${animalId}?userId=${user.id}`);
      setAnimals((prev) => prev.filter((a) => a.id !== animalId));
      setMessage('Post deleted successfully.');
    } catch {
      setMessage('Error deleting the post.');
    }
  };

  const handleMarkAsAdopted = async (animalId) => {
    try {
      // await axios.put(`http://localhost:8080/api/animals/${animalId}/mark-adopted?userId=${user.id}`);
      await axios.put(`/api/animals/${animalId}/mark-adopted?userId=${user.id}`);
      setAnimals((prev) =>
        prev.map((a) =>
          a.id === animalId ? { ...a, adopted: true } : a
        )
      );
      setMessage('Animal marked as adopted.');
    } catch (err) {
      console.error(err);
      setMessage('Failed to mark animal as adopted.');
    }
  };

  return (
    <div className="profile-container">
      <h2>👤 Your Profile</h2>
      <p><strong>Name:</strong> {user?.name}</p>
      <p><strong>Email:</strong> {user?.email}</p>

      <button className="back-button" onClick={() => navigate('/dashboard')}>
        ← Back to Dashboard
      </button>

      <h3>📝 Your Animal Posts</h3>
      {message && <p className="status-message">{message}</p>}

      <div className="animal-list">
        {animals.length === 0 ? (
          <p>No posts yet.</p>
        ) : (
          animals.map((animal) => (
            <div key={animal.id} className="animal-card">
              <img src={animal.imageUrl} alt={animal.name} className="animal-image" />
              <h4>{animal.name}</h4>
              <p><strong>Type:</strong> {animal.type}</p>
              <p><strong>Post Type:</strong> {animal.postType}</p>
              <p><strong>Location:</strong> {animal.location}</p>

              {animal.postType === 'adoption' && animal.adopted ? (
                <span className="adopted-badge">✅ Adopted</span>
              ) : (
                <>
                  <button onClick={() => handleDelete(animal.id)} className="delete-button">
                    🗑 Delete
                  </button>
                  {animal.postType === 'adoption' && !animal.adopted && (
                    <button onClick={() => handleMarkAsAdopted(animal.id)} className="mark-button">
                      ✅ Mark as Adopted
                    </button>
                  )}
                </>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Profile;
